module.exports = __webpack_public_path__ + "school/img/chineseClassicsBg.aae471d2.jpg";